"use client";
import "../../../chunk-MMUBH76A.js";
import { jsx } from "react/jsx-runtime";
import { useModalStore } from "../../stores/index.js";
import { Waiting } from "../Waiting/Waiting.js";
const AwaitingBiometricsStep = () => {
  const isLogin = useModalStore((state) => state.isLogin());
  return /* @__PURE__ */ jsx(
    Waiting,
    {
      heading: isLogin ? "Waiting for Passkey" : "Creating Passkey",
      subheading: "Follow the prompts presented by your browser."
    }
  );
};
export {
  AwaitingBiometricsStep
};
